// What an asset-class switch does from the page the user is on. The route table says how each page
// behaves (`meta.assetClassScope`, `meta.fallback`, `meta.requires` — see router/routes.js); this
// module turns that into a destination, and is the only place that performs the switch.

import { buildAssetClassUrl } from './assetClassSlugs'
import { writeAssetClassNotice } from './assetClassNotice'

const HOME = '/'
const DEFAULT_FALLBACK = '/search'

const NOTICE_RESOURCE = 'navbar.assetClass.notices.resourceNotAvailable'
const NOTICE_UNAVAILABLE = 'navbar.assetClass.notices.pageNotAvailable'

// Route-relative destination for switching `route` to `targetSlug`. The query is always dropped: every
// query parameter of the app refers to a resource or state of the asset class being left.
// `can(permission, assetClass)` answers whether the user holds a permission in the target asset class.
// Returns { path, notice } where notice is an i18n key explaining a redirect, or null.
export function resolveSwitchTarget(route, targetSlug, can) {
  const meta = (route && route.meta) || {}

  switch (meta.assetClassScope) {
    case 'list':
      return { path: meta.fallback || DEFAULT_FALLBACK, notice: NOTICE_RESOURCE }
    case 'home':
      return { path: HOME, notice: null }
    default: {
      if (meta.requires && !can(meta.requires, targetSlug)) {
        return { path: HOME, notice: NOTICE_UNAVAILABLE }
      }
      return { path: (route && route.path) || HOME, notice: null }
    }
  }
}

// Switches to `targetSlug` by reloading on the destination, so that all data already loaded is
// re-scoped. The choice is remembered as the start of the next un-prefixed URL.
export function switchAssetClass({ store, router }, targetSlug) {
  if (targetSlug === store.getters.getSelectedAssetClass) {
    return
  }

  const target = resolveSwitchTarget(router.currentRoute, targetSlug, store.getters.can)
  store.dispatch('selectAssetClass', targetSlug)
  if (target.notice) {
    writeAssetClassNotice(target.notice)
  }
  window.location.assign(buildAssetClassUrl(targetSlug, target.path))
}

// Opens `path` (route-relative) in another asset class than the current one, remembering the choice.
export function openInAssetClass({ store }, targetSlug, path) {
  store.dispatch('selectAssetClass', targetSlug)
  window.location.assign(buildAssetClassUrl(targetSlug, path))
}
